<template>
  <div
    ref="dragResize"
    class="dragResize"
    :style="{
      top: `${boxPosition.top}px`,
      left: `${boxPosition.left}px`,
      ...dragBoxStyle,
    }"
  >
    <div v-if="$slots.header" class="dragResize__header" :style="{ ...dragBoxHeadStyle }" @mousedown="startDrag">
      <slot name="header"></slot>
    </div>
    <div v-if="$slots.body" class="dragResize__body">
      <slot name="body"></slot>
    </div>
    <div v-if="$slots.footer" class="dragResize__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "type", "dragBoxHeadStyle", "dragBoxStyle"],
  data() {
    return {
      isDragging: false,
      offset: { x: 0, y: 0 },
    };
  },
  computed: {
    boxPosition() {
      return this.$store.state.preferences.allPreferences?.[this.type] || { top: 100, left: 700 };
    },
  },

  methods: {
    startDrag(event) {
      this.isDragging = true;
      // // Calculate the offset
      this.offset.x = event.clientX - this.boxPosition.left;
      this.offset.y = event.clientY - this.boxPosition.top;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(event) {
      if (!this.isDragging) return;
      // Update the position of the box
      let left = event.clientX - this.offset.x;
      let top = event.clientY - this.offset.y;

      const maxTop = window.innerHeight - 120;
      const maxRight = window.innerWidth - 50;
      const maxLeft = left + 10;

      top = Math.min(maxTop, Math.max(top, 0));
      left = Math.min(maxRight, maxLeft);

      this.$store.dispatch("preferences/updateWithoutPersist", {
        key: this.type,
        value: { top, left },
      });
    },
    stopDrag() {
      if (this.isDragging) this.$store.dispatch("preferences/persist");
      this.isDragging = false;
      // Remove the event listeners
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      this.$refs.dragResize.focus();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";
.dragResize {
  width: 530px;
  height: 400px;
  resize: both;
  overflow: auto;
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 102;
  color: @kk-color-primary-blue;
  box-shadow: rgba(8, 50, 119, 0.15) -1px 1px 5px 0px, rgba(8, 50, 119, 0.15) 1px 1px 5px 0px;
  padding: 22px;
  border-radius: 8px;
  padding-top: 0px;
  min-height: fit-content;
  min-width: fit-content;
  max-height: 90vh;
  max-width: 90vw;

  &__header {
    padding-top: 22px;
    flex: 0;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: grab;
  }

  &__body {
    flex: 1;
  }

  &__footer {
    margin-top: 1rem;
    flex: 0;
  }
}
</style>
